import Company from '@/App/Company/Entity/Company'
import DraftMeeting from '@/App/Booking/Draft/Entity/DraftMeeting'
import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
import { IntegrationProviderEnum } from '@/Shared/AutoGenerated/Main'
import { RoutePathBookingFormEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
import { simulateMatchExpressionExhaustiveness } from '@/Shared/Helper/SimulateMatchExpression'
import { UrlFactory } from '@/Shared/Url/UrlFactory'

/// WTFH IS THIS SHIT???? AI SLOP????
export default class BookingConfirmationSubmitUrlFactory {
    build(
        company: Company,
        draftMeeting: DraftMeeting,
        serviceAggregate: ServiceAggregate,
        locale: string,
    ): string {
        const routePath = this.getRoutePath(serviceAggregate)

        return new UrlFactory().makeBookingConfirmationSubmitUrl(
            routePath,
            company.slug,
            serviceAggregate.service.slug,
            draftMeeting.id.value,
            locale,
        )
    }

    private getRoutePath(
        serviceAggregate: ServiceAggregate,
    ): RoutePathBookingFormEnum {
        if (serviceAggregate.isPaymentNotRequired()) {
            return RoutePathBookingFormEnum.Step_Confirmation
        }

        const provider = serviceAggregate.integration?.provider

        switch (provider) {
            case IntegrationProviderEnum.StripeConnect:
                return RoutePathBookingFormEnum.Step_Confirmation_Stripe
            case IntegrationProviderEnum.PayPalMultiParty:
                return RoutePathBookingFormEnum.Step_Confirmation_PayPal
            case IntegrationProviderEnum.Void:
            case IntegrationProviderEnum.GoogleCalendar:
            case IntegrationProviderEnum.OutlookCalendar:
            case IntegrationProviderEnum.GoogleMeet:
            case IntegrationProviderEnum.Zoom:
            case undefined:
                throw new Error(`Unsupported payment provider '${provider}'.`)
            default:
                return simulateMatchExpressionExhaustiveness(provider)
        }
    }
}
